import HttpClient from "./HttpClient";
import environment from "./variables";
import StorageHelper from "./StorageHelper";
import Storage from "./StorageHelper";

class Management extends HttpClient {
    constructor() {
        super(environment.apiEndpoint!);
    }

    async deleteDuplicates(vehicleSaleIds: number[]) {
        try {
            return await this.client.post('/validation', {
                ids: vehicleSaleIds
            }, {
                headers: {
                    "Authorization": `Bearer ${StorageHelper.getIdToken()}`
                }
            });
        } catch (e) {
            console.error("Can't download RDS dump");
            throw (e)
        }
    }

    async getRDSDump() {
        try {
            return await this.client.get('/datadownload', {
                headers: {
                    "Authorization": `Bearer ${StorageHelper.getIdToken()}`
                },
                responseType: "blob"
            });
        } catch (e) {
            console.error("Can't download RDS dump");
            throw (e)
        }
    }

    async getVINs() {
        try {
            return await this.client.get('/validation', {
                headers: {
                    "Authorization": `Bearer ${StorageHelper.getIdToken()}`
                }
            });
        } catch (e) {
            console.error("Can't get VINs");
            throw (e)
        }
    }

    async verifyCaptcha(response: string) {

        const urlencoded = new URLSearchParams();
        urlencoded.append("response", response);
        try {
            return await this.client.post('/re-captcha', urlencoded, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
            });
        } catch (e) {
            console.error("Can't validate captcha");
            throw (e)
        }
    }

    async upload(formData: FormData, progress: any) {
        try {
            return await this.client.post('/upload', formData, {
                headers: {
                    "Authorization": `Bearer ${StorageHelper.getIdToken()}`,
                    "Content-Type": "multipart/form-data"
                },
                onUploadProgress: progress
            });
        } catch (e) {
            console.error("Can't upload file");
            throw (e)
        }
    }

    async getStates() {
        try {
            return await this.client.get('/states');
        } catch (e) {
            console.error('Can\'t get states');
            throw (e)
        }
    }

    async forgotPasswordSendCode(email: string) {
        try {
            return await this.client.get(`/password/forgot/${email}`, {
                headers: {
                    "Authorization": `Bearer ${StorageHelper.getIdToken()}`
                }
            })
        } catch (e) {
            console.error("Can't send code")
            throw (e);
        }
    }

    async forgotPasswordChangePassword(payload: {
        username: string;
        password: string;
        code: string;
    }) {
        try {
            return await this.client.post(`/password/forgot`,
                payload
            )
        } catch (e) {
            console.error("Can't send code")
            throw (e);
        }
    }

    async updatePassword(previousPassword: string, newPassword: string) {
        try {
            const {data} = await this.refreshToken();
            Storage.update(data.AuthenticationResult.IdToken, data.AuthenticationResult.AccessToken)
            return await this.client.post(`/password/change`, {
                previousPassword,
                newPassword,
                accessToken: data.AuthenticationResult.AccessToken
            }, {
                headers: {
                    "Authorization": `Bearer ${StorageHelper.getIdToken()}`
                }
            })
        } catch (e) {
            console.error("Can't change user password")
            throw (e);
        }
    }

    async changePassword(username: string, password: string, session: string) {
        try {
            return await this.client.post(`/login/challenge`, {
                username,
                password,
                session
            })
        } catch (e) {
            console.error("Can't change user password")
            throw (e);
        }
    }

    async getManufacturers() {
        try {
            const manufacturer = await this.client.get('/groups', {
                headers: {
                    "Authorization": `Bearer ${StorageHelper.getIdToken()}`
                }
            })

            // the return of the "/grous", need to change like this
            const manufacturerData = manufacturer.data.map( (data: any) => {
                return {
                    label: data,
                    value: data
                }
            })
            return {... manufacturer, data: manufacturerData}
        } catch (e) {
            console.error('Can\'t get manufacturers');
            throw (e)
        }
    }

    async getDestinationFolder() {
        try {
            return await this.client.get('/manufacturers/folders', {
                headers: {
                    "Authorization": `Bearer ${StorageHelper.getIdToken()}`
                }
            })
        } catch (e) {
            console.error("Can't get destination folders")
            throw (e);
        }
    }

    async getSecureLink(group: string) {
        try {
            return await this.client.post('/token', {
                group
            }, {
                headers: {
                    "Authorization": `Bearer ${StorageHelper.getIdToken()}`
                }
            })
        } catch (e) {
            console.error("Can't get token")
            throw (e);
        }
    }

    async verifyToken(token: string) {
        try {
            return await this.client.post('/token/verify', {
                token
            })
        } catch (e) {
            console.error("Can't get token")
            throw (e);
        }
    }

    async signIn(email: string, password: string) {
        try {
            return await this.client.post('/login', {
                email,
                password
            })
        } catch (e) {
            console.error("Can't log user in")
            throw (e);
        }
    }

    async signUp(payload: {
        email: string;
        password: string;
        manufacturer: string;
        name: string;
    }) {
        try {
            return await this.client.post('/register', payload)
        } catch (e) {
            console.error("Can't log user in")
            throw (e);
        }
    }
}

export default Management;
